export const DEFAULT_LLM_SORT_PRESET = 'name-desc';

export const LLM_SORT_PRESETS: Record<
  string,
  { label: string; sort_col: string; sort_order: 'asc' | 'desc' }
> = {
  'name-asc': { label: 'Name (A→Z)', sort_col: 'name', sort_order: 'asc' },
  'name-desc': { label: 'Name (Z→A)', sort_col: 'name', sort_order: 'desc' },
  'band-asc': { label: 'Band (1→5)', sort_col: 'routing_band', sort_order: 'asc' },
  'band-desc': { label: 'Band (5→1)', sort_col: 'routing_band', sort_order: 'desc' },
  'score-desc': { label: 'Score (high→low)', sort_col: 'model_score', sort_order: 'desc' },
  'score-asc': { label: 'Score (low→high)', sort_col: 'model_score', sort_order: 'asc' },
};

export const LLM_STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'All statuses' },
  { value: 'active', label: 'Active' },
  { value: 'testing', label: 'Testing' },
  { value: 'disabled', label: 'Disabled' },
  { value: 'deprecated', label: 'Deprecated' },
];
